import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InfoPage from "@/components/templates/InfoPage.vue";
import ContentShowcase from "../organisms/ContentShowcase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoPage, { icon: "music" }, {
    default: _withCtx(() => [
      _createVNode(ContentShowcase, {
        category: "music",
        instrument: "rhodes"
      })
    ]),
    _: 1
  }))
}
}

})